import { render, staticRenderFns } from "./speedtest.view.vue?vue&type=template&id=74f31d97&scoped=true"
import script from "./speedtest.view.vue?vue&type=script&lang=js"
export * from "./speedtest.view.vue?vue&type=script&lang=js"
import style0 from "./speedtest.view.vue?vue&type=style&index=0&id=74f31d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f31d97",
  null
  
)

export default component.exports